<!-- <ng-template pTemplate="paginatorright"> -->
<div class="tableRowCount">
  <span>
    {{'de.his.faces.tags.table.datascroller.numRowsFound.label' | hisUi}}
    {{i18nKeyForRecords() | hisUi: effectiveState().totalRowCount}} |
    @if (effectiveState().totalNumberOfPages > 1) {
      {{'de.his.faces.tags.table.datascroller.numRowsFound.page' | hisUi: effectiveState().currentPageNumber : effectiveState().totalNumberOfPages }} |
    }
    <label for="tableRow">
      @if (maxRows()) {
        <span>
          {{ 'de.his.faces.tags.table.datascroller.numRowsPerPage' | hisUi }} (max.: {{maxRows()}})
        </span>
      } @else {
        {{ 'de.his.faces.tags.table.datascroller.numRowsPerPage' | hisUi }} {{'de.his.faces.tags.table.datascroller.maxNumRowsPerPage' | hisUi }}
      }
    </label>
    <input #content required id="tableRow"
      [value]="effectiveState().rowsPerPageValue"
      (change)="changed($event)"
      [hisDisableModificationDetection]="true"
      class="input_3_Chars tableRowInput">
  </span>
</div>
<!-- </ng-template> -->